import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-common-workflow-delete-task',
  templateUrl: './common-workflow-delete-task.component.html',
  styleUrls: ['../parts.css']
})
export class CommonWorkflowDeleteTaskComponent implements OnInit {

  statusList = [
    {code: 'ACTIVE', name: '处理中'},
    {code: 'SUSPENDED', name: '暂停'},
    {code: 'COMPLETED', name: '正常结束'},
    {code: 'INTERNALLY_TERMINATED', name: '终止'},
    {code: 'EXTERNALLY_TERMINATED', name: '终止(外部)'}
    ];
  statusDisplayText = '状态';
  statusConditionVisible = false;
  statusConditionCode = '';

  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  categorieId: string; // 存放当前目录ID
  automation = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    processStatus: '',
    processCategory: 'processStatusChange',
    instanceDescription: ''
  }; // 存放入参数据
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
    // 处理返填数据
    if (this.instanceData && this.instanceData.config) {
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.statusConditionCode = this.automation.processStatus;
      for (const item of this.statusList) {
        if (item.code === this.statusConditionCode) {
          this.statusDisplayText = item.name;
          break;
        }
      }
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.packageData();
  }

  statusConditionChange(item) {
    this.statusConditionCode = item.code;
    this.statusDisplayText = item.name;
    this.automation.processStatus = item.code;
    this.statusConditionVisible = false;
    this.packageData();
  }

  // 组件提交数据
  packageData() {
    this.automation.instanceDescription = '监听到流程待办变更为 ' + this.statusDisplayText + ' 时，删除任务 ';
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus() : boolean {
    return this.statusConditionCode != '';
  }
}
